import { ReactElement } from 'react';
import { BonusForm, RateGroups } from 'modules/guarantee/common/bonus';
import permissions from 'modules/guarantee/cvb/permissions';
import { useField } from '@ff-it/form';
import { Alert } from '@ff-it/ui';

// @TODO
function AmbiguityWarning(): ReactElement | null {
  const {
    input: { value: rates },
  } = useField<any[]>('groups', { subscription: { value: true } });
  let justClient = false;
  let justPayer = false;

  // We get undefiened if last one is removed (final-from bug)
  (rates || []).forEach(({ client, payer }) => {
    if (client && !payer) {
      justClient = true;
    }
    if (!client && payer) {
      justPayer = true;
    }
  });

  if (justClient && justPayer) {
    return (
      <Alert variant="warning" heading="Lookup ambiguity">
        Avoid mixing client only and payer only rows in single document
      </Alert>
    );
  }

  return null;
}

export function Form(): ReactElement {
  return (
    <BonusForm sensitive={permissions.sensitive_info}>
      <AmbiguityWarning />
      <RateGroups bonusType="CVB" />
    </BonusForm>
  );
}
